import { render, staticRenderFns } from "./PreferredLocale.vue?vue&type=template&id=51c6eeda&"
import script from "./PreferredLocale.vue?vue&type=script&lang=js&"
export * from "./PreferredLocale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports